import { AsNumber, IconChevron, RadioButton, Spacer } from '@adserve/adserve-react-components';
import React, { useState, useContext, useEffect } from 'react';
import WeeklyBudgetDropdownTongue from './WeeklyBudgetDropdownTongue';
import { SystemSettingsContext } from '../../../../contexts/SystemSettingsContext';

const disabledStyle = {
    backgroundColor: '#f7f7f7',
    cursor: 'default',
    opacity: 1
};

const WeeklyBudgetDropdown = ({
    id,
    title,
    values,
    totalBudget,
    labelStyle,
    inputStyle,
    disabled = false,
    onValueChange,
    symbol = '',
    selected,
    invalid,
    onClick,
    generateBudgetsArray,
    onApplyChanges
}) => {
    const { formatCurrency, formatNumber } = useContext(SystemSettingsContext);

    const [isExpanded, setIsExpanded] = useState(false);
    const [changeMade, setChangeMade] = useState(false);
    const [isMultiple, setIsMultiple] = useState(false);
    const [localValue, setLocalValue] = useState();

    labelStyle = {
        color: '#414141',
        display: 'block',
        fontFamily: 'roboto',
        fontSize: 12,
        textAlign: 'left',
        ...labelStyle
    };

    inputStyle = {
        boxSizing: 'border-box',
        height: 37,
        width: '100%',
        padding: 12,
        marginTop: 6,
        textAlign: 'left',
        border: '1px solid #d7d7d7',
        borderRadius: 5,
        resize: 'vertical',
        alignItems: 'center',
        backgroundColor: '#fffdf4',
        color: '#414141',
        outline: 'none',
        autoComplete: 'off',
        position: 'relative',
        userSelect: 'none',
        KhtmlUserSelect: 'none',
        MsUserSelect: 'none',
        MozUserSelect: 'none',
        WebkitUserSelect: 'none',
        fontWeight: 600,
        fontSize: 15,
        zIndex: 1,
        ...(disabled ? disabledStyle : {}),
        ...inputStyle
    };

    const handleDropdownClick = () => {
        if (!selected) return;

        setIsExpanded(!isExpanded);
    };

    useEffect(() => {
        if (values?.length > 0) {
            const firstValue = values[0].value;
            let multiple = false;

            for (let index = 0; index < values.length; index++) {
                if (firstValue !== values[index].value) {
                    multiple = true;
                    break;
                }
            }

            if (!multiple) {
                setLocalValue(firstValue);
            }

            setIsMultiple(multiple);
        } else {
            setIsMultiple(false);
            setLocalValue();
        }
    }, [values]);

    return (
        <div style={{ display: 'flex', flexDirection: 'column' }}>
            <div style={{ display: 'flex', alignItems: 'center', marginRight: 10 }}>
                <div style={{ width: 16, marginTop: 20 }}>
                    <RadioButton
                        id={`${id}-radio`}
                        checkStyle={{ marginTop: 0 }}
                        disabled={disabled}
                        value={selected}
                        onClick={onClick}
                    />
                </div>
                <Spacer width={6} />
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <AsNumber
                        id={id}
                        name={id}
                        title={window.translate(title)}
                        labelStyle={labelStyle}
                        inputStyle={{
                            ...inputStyle,
                            backgroundColor: selected && invalid ? 'rgb(255, 243, 243)' : !selected || disabled ? 'rgb(247, 247, 247)' : 'rgb(255, 253, 244)',
                            border: selected && invalid ? '1px solid rgb(196,6,6)' : '1px solid rgb(215,215,215)',
                            ...(symbol ? { textAlign: 'left', paddingLeft: 34 } : {})
                        }}
                        value={isMultiple ? '(Multiple)' : localValue}
                        onChange={onValueChange}
                        disabled={!selected || disabled}
                        allowFloat={true}
                        formatCurrency={formatCurrency}
                    />
                    <div style={{
                        position: 'absolute',
                        alignSelf: 'flex-end',
                        marginTop: 30,
                        marginRight: 10,
                        zIndex: 1 }}
                    >
                        <IconChevron
                            size={15}
                            style={{
                                boxSizing: 'border-box',
                                cursor: 'pointer'
                            }}
                            onClick={handleDropdownClick}
                        />
                    </div>
                </div>
            </div>

            <div style={{ position: 'relative' }}>
                {isExpanded ? (
                    <WeeklyBudgetDropdownTongue
                        id={id}
                        weeklyBudget={isMultiple ? '-' : localValue}
                        weeklyBudgets={values}
                        totalBudget={totalBudget}
                        onBudgetChange={onValueChange}
                        scriptFactors={[]}
                        onClose={handleDropdownClick}
                        changeMade={changeMade}
                        disabled={disabled}
                        generateBudgetsArray={generateBudgetsArray}
                        onApplyChanges={onApplyChanges}
                    />
                ) : null}
            </div>
        </div>
    );
};

export default WeeklyBudgetDropdown;
